module.exports = __webpack_public_path__ + "img/camera.5cc8b1f3.svg";